<template>
    <v-container class="mb-4">

        <v-row class="ma-0 pa-0 mb-2">
            <v-spacer />
            <v-btn color="success" @click="apriDialogEsporta" :disabled="!dati.length">
                <v-icon left>grid_on</v-icon> Esporta Excel
            </v-btn>
        </v-row>

        <v-data-table :headers="headers" :items="dati" :search="search" item-key="Id" :no-data-text="''"
            no-results-text="Nessun dato trovato" mobile-breakpoint="0" @click:row="rowClicked"
            :expanded.sync="expanded" single-expand hide-default-footer :items-per-page="-1">
            <!-- RIGA PRINCIPALE -->
            <template v-slot:item="{ item }">
                <tr @click="setCliente(item); rowClicked(item)" style="cursor:pointer"
                    :style="{ backgroundColor: item.Blocca ? '#ff5050' : '' }">
                    <td>{{ item.TipoCliente }}</td>
                    <td>{{ item.RagioneSociale }}</td>
                    <td>{{ item.PartitaIVA }}</td>
                    <td>{{ item.Email }}</td>
                    <td>{{ item.Telefono }}</td>
                    <td>{{ item.DataInserimento != "0001-01-01T00:00:00" ?
                        $i2kFunctions.formatISODate(item.DataInserimento) : "" }}</td>
                    <td class="text-center">
                        <v-icon v-if="item.Esportato" color="green" title="Esportato">check_circle</v-icon>
                        <v-icon v-else color="grey lighten-1" title="Non esportato">radio_button_unchecked</v-icon>
                    </td>
                </tr>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" style="padding:0; background-color: #f0f0f0;">
                    <v-col>
                        <v-alert v-if="!campiObbligatoriOk(item)" dense type="warning" outlined class="mb-2">
                            Compilare tutti i campi obbligatori evidenziati con <strong>*</strong> prima di salvare.
                        </v-alert>

                        <v-row class="ma-0 pa-0">
                            <v-select v-model="item.TipoCliente" label="Tipo *" :items="tipoClienti"
                                :rules="[rules.required]" class="mr-2" style="max-width: 250px !important;" />
                            <v-text-field v-model="item.RagioneSociale" label="Ragione sociale *"
                                :rules="[rules.required]" class="mr-2" />
                            <v-text-field v-model="item.PartitaIVA" label="Partita IVA *" :rules="[rules.required]" />
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-text-field v-model="item.Email" label="Email" />
                            <v-text-field v-model="item.Telefono" label="Telefono" />
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-textarea v-model="item.Note" label="Note" rows="2" />
                        </v-row>

                        <v-card outlined v-for="(ind, i) in item.IndirizziDett" :key="i"
                            style="background-color: #f0f0f0;" class="ma-2 pt-4 pl-2 d-flex align-center flex-wrap">
                            <v-text-field v-model="ind.Indirizzo" label="Indirizzo *" :rules="[rules.required]"
                                class="mr-2" style="min-width: 220px;" dense />

                            <v-text-field v-model="ind.Localita" label="Località *" :rules="[rules.required]"
                                class="mr-2" style="min-width: 180px;" dense />

                            <v-text-field v-model="ind.Provincia" label="Provincia *" :rules="[rules.required]"
                                maxlength="2" class="mr-2" style="max-width: 110px;" dense />

                            <v-text-field v-model="ind.Latitudine" label="Latitudine" type="number" class="mr-2"
                                style="max-width: 140px;" dense />

                            <v-text-field v-model="ind.Longitudine" label="Longitudine" type="number" class="mr-2"
                                style="max-width: 140px;" dense />

                            <v-btn icon @click.stop="removeIndirizzo(item, i)">
                                <v-icon color="red">delete</v-icon>
                            </v-btn>
                        </v-card>

                        <v-row class="ma-0 pa-0">
                            <v-btn color="primary" @click.stop="salvaRiga(item)" class="ma-4">
                                <v-icon>save</v-icon> Salva dati
                            </v-btn>
                            <v-btn small @click.stop="eliminaRiga(item)" class="ma-4">
                                <v-icon>delete</v-icon> Elimina cliente
                            </v-btn>
                            <v-spacer />
                            <v-btn @click.stop="addIndirizzo(item)" class="ma-4" small>
                                <v-icon color="green">add</v-icon> Aggiungi indirizzo
                            </v-btn>
                        </v-row>
                    </v-col>
                </td>
            </template>
        </v-data-table>

        <!-- Dialog scelta esportazione, visibile solo agli Admin -->
        <v-dialog v-model="dialogEsporta" max-width="420">
            <v-card>
                <v-card-title>Esporta Excel</v-card-title>
                <v-card-text>
                    <v-radio-group v-model="modalitaEsportazione" column>
                        <v-radio label="Solo clienti non ancora esportati" value="nonEsportati" />
                        <v-radio label="Tutti i clienti potenziali" value="tutti" />
                    </v-radio-group>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogEsporta = false">Annulla</v-btn>
                    <v-btn color="success" @click="confermaEsporta">Esporta</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import { get_tipoClienti, get_clientiPotenziali, salva_clientiPotenziali, del_clientiPotenziali, segna_esportati_clientiPotenziali } from '@/api/api.agenti';
import * as XLSX from 'xlsx';

export default {
    props: {
        search: { type: String, default: "" },
    },

    data: () => ({
        dati: [],
        headers: [
            { text: "Tipo cliente", align: "start", value: "TipoCliente" },
            { text: "Cliente", align: "start", value: "RagioneSociale" },
            { text: "PartitaIVA", align: "start", value: "PartitaIVA" },
            { text: "EMail", align: "start", value: "Email" },
            { text: "Telefono", align: "start", value: "Telefono" },
            { text: "Data inserimento", align: "start", value: "DataInserimento" },
            { text: "Esportato", align: "center", value: "Esportato" }
        ],
        expanded: [],
        singleExpand: false,
        rowClickedData: [],
        selectedRow: {},
        codClienteSel: -1,
        tipoClienti: [],
        rules: {
            required: v => (!!v && String(v).trim() !== "") || "Campo obbligatorio",
        },
        dialogEsporta: false,
        modalitaEsportazione: "nonEsportati",
    }),

    computed: {
        role() {
            return this.$store.getters["user/getRole"];
        },
    },

    methods: {
        async caricaDati() {

            let res = await get_tipoClienti();
            this.tipoClienti = res.data;

            let par = "";
            let userSwitch = this.$store.getters["user/getUserSwitch"];
            if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;
            else if (this.$store.getters["user/getCodice"])
                par = "agente" + "/" + this.$store.getters["user/getCodice"];

            res = await get_clientiPotenziali(par);
            this.dati = res.data;
        },

        setCliente(props) {
            this.selectedRow = props;
        },

        rowClicked(props) {
            this.rowClickedData = props;
            this.expanded = [];
            props.expanded = !props.expanded;
            if (!props.expanded) {
                this.ResetExpanded();
                return;
            }
            this.expanded.push(props);
            this.codClienteSel = props.Id;
        },

        ResetExpanded() {
            this.dati.forEach((el) => {
                el.expanded = false;
            });
        },

        addIndirizzo(item) {
            if (!item.IndirizziDett) item.IndirizziDett = [];

            const maxCod = item.IndirizziDett.length
                ? Math.max(...item.IndirizziDett.map(i => i.CodiceIndirizzo))
                : 0;

            item.IndirizziDett.push({
                CodiceIndirizzo: maxCod + 1,
                Indirizzo: "",
                Localita: "",
                Provincia: "",
                Latitudine: "",
                Longitudine: "",
            });
        },

        removeIndirizzo(item, index) {
            item.IndirizziDett.splice(index, 1);
        },

        // Verifica i campi obbligatori: anagrafica cliente + ogni indirizzo
        campiObbligatoriOk(item) {
            const anagraficaOk = !!item.TipoCliente && !!item.RagioneSociale && !!item.PartitaIVA;
            const indirizziOk = (item.IndirizziDett || []).every(
                ind => !!ind.Indirizzo && !!ind.Localita && !!ind.Provincia
            );
            return anagraficaOk && indirizziOk;
        },

        async salvaRiga(item) {
            if (!this.campiObbligatoriOk(item)) {
                this.$toast.alert("Compilare tutti i campi obbligatori (*) prima di salvare");
                return;
            }

            let res = await salva_clientiPotenziali("", item)
            if (res.data == "OK") {
                this.$toast.info("Dati salvati");
                this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },
        async eliminaRiga(item) {

            let confirm = await this.$root.$confirm(
                "Elimina",
                "Vuoi eliminare il cliente e tutti i suoi dati?"
            );
            if (!confirm) return;

            let res = await del_clientiPotenziali("", item)
            if (res.data == "OK") {
                this.$toast.info("Cliente eliminato");
                this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        apriDialogEsporta() {
            if (!this.dati.length) {
                this.$toast.info("Nessun dato da esportare");
                return;
            }

            if (this.role === "Admin") {
                this.modalitaEsportazione = "nonEsportati";
                this.dialogEsporta = true;
            } else {
                // utenti non Admin: esporta sempre solo i non esportati, senza chiedere
                this.eseguiEsportazione("nonEsportati");
            }
        },

        confermaEsporta() {
            this.dialogEsporta = false;
            this.eseguiEsportazione(this.modalitaEsportazione);
        },

        async eseguiEsportazione(modalita) {
            const datiDaEsportare = modalita === "tutti"
                ? this.dati
                : this.dati.filter(item => !item.Esportato);

            if (!datiDaEsportare.length) {
                this.$toast.info("Nessun cliente da esportare con il filtro selezionato");
                return;
            }

            // Foglio 1: dati principali clienti
            const righeClienti = datiDaEsportare.map(item => ({
                "Tipo cliente": item.TipoCliente,
                "Cliente": item.RagioneSociale,
                "Partita IVA": item.PartitaIVA,
                "Email": item.Email,
                "Telefono": item.Telefono,
                "Note": item.Note,
                "Data inserimento": item.DataInserimento && item.DataInserimento != "0001-01-01T00:00:00"
                    ? this.$i2kFunctions.formatISODate(item.DataInserimento)
                    : "",
                "Esportato": item.Esportato ? "Sì" : "No",
            }));

            // Foglio 2: dettaglio indirizzi, collegato tramite Id/RagioneSociale
            const righeIndirizzi = [];
            datiDaEsportare.forEach(item => {
                (item.IndirizziDett || []).forEach(ind => {
                    righeIndirizzi.push({
                        "Cliente": item.RagioneSociale,
                        "Partita IVA": item.PartitaIVA,
                        "Indirizzo": ind.Indirizzo,
                        "Località": ind.Localita,
                        "Provincia": ind.Provincia,
                        "Latitudine": ind.Latitudine,
                        "Longitudine": ind.Longitudine,
                    });
                });
            });

            const wb = XLSX.utils.book_new();

            const wsClienti = XLSX.utils.json_to_sheet(righeClienti);
            XLSX.utils.book_append_sheet(wb, wsClienti, "Clienti");

            if (righeIndirizzi.length) {
                const wsIndirizzi = XLSX.utils.json_to_sheet(righeIndirizzi);
                XLSX.utils.book_append_sheet(wb, wsIndirizzi, "Indirizzi");
            }

            const dataStr = new Date().toISOString().slice(0, 10);
            XLSX.writeFile(wb, `ClientiPotenziali_${dataStr}.xlsx`);

            // segna come esportati sul server e localmente
            const ids = datiDaEsportare.map(item => item.Id);
            try {
                let res = await segna_esportati_clientiPotenziali(ids);
                if (res.data == "OK") {
                    datiDaEsportare.forEach(item => {
                        item.Esportato = true;
                        item.DataEsportazione = new Date().toISOString();
                    });
                } else {
                    this.$toast.alert("Excel generato, ma non è stato possibile aggiornare lo stato di esportazione");
                }
            } catch (e) {
                this.$toast.alert("Excel generato, ma non è stato possibile aggiornare lo stato di esportazione");
            }
        }
    },

    mounted() {
        this.caricaDati();
    }
}
</script>